export const ACTIVE_WINDOW_MS = 60 * 1000;

// Pure state machine for visible, active wall-clock time. Consumers flush the
// returned positive duration to analytics; each interval is consumed once.
export function createActiveTimeTracker(now, { visible = true } = {}) {
  let lastAccounted = now;
  let activeUntil = visible ? now + ACTIVE_WINDOW_MS : now;
  let isVisible = visible;
  let pendingMs = 0;

  const accrue = (at) => {
    if (!Number.isFinite(at) || at < lastAccounted) return 0;
    const end = isVisible ? Math.min(at, activeUntil) : lastAccounted;
    const elapsed = Math.max(0, end - lastAccounted);
    // A later activity must not backfill an idle gap.
    lastAccounted = at;
    return elapsed;
  };

  return {
    activity(at) {
      pendingMs += accrue(at);
      if (isVisible) activeUntil = at + ACTIVE_WINDOW_MS;
    },
    visibility(at, nextVisible) {
      pendingMs += accrue(at);
      isVisible = !!nextVisible;
      lastAccounted = at;
      activeUntil = isVisible ? at + ACTIVE_WINDOW_MS : at;
      const elapsed = pendingMs;
      pendingMs = 0;
      return elapsed;
    },
    flush(at) {
      pendingMs += accrue(at);
      const elapsed = pendingMs;
      pendingMs = 0;
      return elapsed;
    },
    stop(at) {
      pendingMs += accrue(at);
      isVisible = false;
      activeUntil = at;
      const elapsed = pendingMs;
      pendingMs = 0;
      return elapsed;
    },
  };
}
